// import { useSelector, useDispatch } from "react-redux";
// import React, { useEffect, useRef } from 'react';
// import MonthGraph from '../../components/Dashboard/Graph.jsx';
// import FilterCalendar from '../../components/Dashboard/FilterCalendar';
// import AmountOverview from '../../components/Dashboard/AmountOverview';
// import RecentInvoices from '../../components/Dashboard/RecentInvoice.jsx';
// import { motion } from 'framer-motion';

// export default function Dashboard() {
//   const dispatch = useDispatch();
//   const user = useSelector(
//     (state) => state.auth.user
//   )
//   const sum = useSelector(
//     (state) => state.invoice.dashboardCurrencySum
//   )
//   const componentRef = useRef(null);
//   useEffect(() => {
//     componentRef.current.scrollTop = 0;
//   }, [dispatch, user]);

//   const fadeIn = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1 }
//   };


//   return (
//     <motion.div
//       ref={componentRef}
//       initial="hidden"
//       animate="visible"
//       variants={fadeIn}
//       transition={{ duration: 0.3 }}
//     >
//       <div ref={componentRef}>
//         <>
//           <div className='filter-sec'>
//             <FilterCalendar sum={sum} />
//           </div>
//           <div className='graph-overview'>
//             <div className='overview-left'>
//               <AmountOverview sum={sum} />
//             </div>
//             <MonthGraph sum={sum} />
//           </div>
//           <div className='recent-invoices'>
//             <div className='recent-invoice-inner'>
//               <RecentInvoices sum={sum} />
//             </div>
//           </div>
//         </>
//       </div>
//     </motion.div>

//   )
// }

import React, { useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import { motion } from 'framer-motion';
import { RotatingLines } from 'react-loader-spinner';
import './Dashboard.css';

// Direct imports (no lazy loading)
import MonthGraph from '../../components/Dashboard/Graph.jsx';
import FilterCalendar from '../../components/Dashboard/FilterCalendar.jsx';
import AmountOverview from '../../components/Dashboard/AmountOverview.jsx';
import RecentInvoices from '../../components/Dashboard/RecentInvoice.jsx';

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const Loader = () => (
  <div className="loader">
    <RotatingLines
      strokeColor="grey"
      strokeWidth="5"
      animationDuration="0.75"
      width="40"
      visible={true}
    />
  </div>
);

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <h3>Something went wrong while loading the page.</h3>;
    }

    return this.props.children;
  }
}

export default function Dashboard() {
  const sum = useSelector((state) => state.invoice.dashboardCurrencySum);
  const componentRef = useRef(null);

  useEffect(() => {
    if (componentRef.current) {
      componentRef.current.scrollTop = 0;
    }
  }, []);

  return (
    <motion.div
      ref={componentRef}
      initial="hidden"
      animate="visible"
      variants={fadeIn}
      transition={{ duration: 0.3 }}
      className="dashboard-container"
    >
      <ErrorBoundary>
        <div className='filter-sec'>
          <FilterCalendar sum={sum} />
        </div>

        <div className='graph-overview'>
          <div className='overview-left'>
            <AmountOverview sum={sum} />
          </div>

          <MonthGraph sum={sum} />
        </div>

        <div className='recent-invoices'>
          <div className='recent-invoice-inner'>
            <RecentInvoices sum={sum} />
          </div>
        </div>
      </ErrorBoundary>
    </motion.div>
  );
}
